import React from 'react';
import Icon from 'components/AppIcon';

const PortfolioOverview = ({ portfolioData, timeframe, onTimeframeChange }) => {
  const timeframes = [
    { value: '24h', label: '24H' },
    { value: '7d', label: '7D' },
    { value: '30d', label: '30D' }
  ];

  const getChangeData = () => {
    switch (timeframe) {
      case '7d':
        return {
          change: portfolioData.totalChange7d,
          changePercent: portfolioData.totalChangePercent7d
        };
      case '30d':
        return {
          change: portfolioData.totalChange30d,
          changePercent: portfolioData.totalChangePercent30d
        };
      default:
        return {
          change: portfolioData.totalChange24h,
          changePercent: portfolioData.totalChangePercent24h
        };
    }
  };

  const { change, changePercent } = getChangeData();
  const isPositive = change >= 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {/* Total Portfolio Value */}
      <div className="md:col-span-2 bg-surface border border-border rounded-trading p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-heading-semibold text-text-primary">
            Total Portfolio Value
          </h2>
          
          <div className="flex items-center space-x-1">
            {timeframes.map((tf) => (
              <button
                key={tf.value}
                onClick={() => onTimeframeChange(tf.value)}
                className={`px-3 py-1 text-xs font-body-medium rounded-trading transition-colors duration-trading-fast ${
                  timeframe === tf.value
                    ? 'bg-primary text-white' :'text-text-secondary hover:text-text-primary hover:bg-secondary-50'
                }`}
              >
                {tf.label}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-2">
          <div className="text-3xl font-heading-bold text-text-primary">
            ${portfolioData.totalValue.toLocaleString('en-US', { 
              minimumFractionDigits: 2, 
              maximumFractionDigits: 2 
            })}
          </div>
          
          <div className="flex items-center space-x-2">
            <div className={`flex items-center space-x-1 ${isPositive ? 'text-success' : 'text-error'}`}>
              <Icon 
                name={isPositive ? 'TrendingUp' : 'TrendingDown'} 
                size={16} 
              />
              <span className="font-body-medium text-sm">
                {isPositive ? '+' : ''}${Math.abs(change).toLocaleString('en-US', { 
                  minimumFractionDigits: 2, 
                  maximumFractionDigits: 2 
                })}
              </span>
              <span className="font-body-medium text-sm">
                ({isPositive ? '+' : ''}{changePercent.toFixed(2)}%)
              </span>
            </div>
            <span className="text-text-secondary font-caption-normal text-xs">
              {timeframe.toUpperCase()}
            </span>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center space-x-2 text-text-secondary">
            <Icon name="Clock" size={14} />
            <span className="font-caption-normal text-xs">
              Last updated: {portfolioData.lastUpdated.toLocaleTimeString()}
            </span>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="space-y-4">
        <div className="bg-surface border border-border rounded-trading p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="TrendingUp" size={16} className="text-success" />
            <span className="font-body-medium text-sm text-text-secondary">Best Performer</span>
          </div>
          <div className="text-lg font-heading-semibold text-text-primary">BTC</div>
          <div className="text-success font-body-medium text-sm">+4.98%</div>
        </div>

        <div className="bg-surface border border-border rounded-trading p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="PieChart" size={16} className="text-primary" />
            <span className="font-body-medium text-sm text-text-secondary">Total Assets</span>
          </div>
          <div className="text-lg font-heading-semibold text-text-primary">5</div>
          <div className="text-text-secondary font-body-medium text-sm">Cryptocurrencies</div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioOverview;